import { Box, Chip, Typography } from '@mui/material';
import { isEmptyArray, takeFromStart } from '@vy/utils';
import { useSwallowClick } from '../../../../../hooks/use-swallow-click';
import { SelectItem } from './VyCheckboxSelect';

type VyCheckboxSelectChipsProps = {
  selectedItems: SelectItem[];
  onDelete?: (item: SelectItem) => void;
  placeholder?: string;
  hidden?: boolean;
  maxChipsInInputArea?: number;
};

export const VyCheckboxSelectChips: React.FC<VyCheckboxSelectChipsProps> = ({
  selectedItems,
  onDelete,
  placeholder = '',
  hidden = false,
  maxChipsInInputArea = 2,
}) => {
  const swallowClick = useSwallowClick();

  if (hidden || isEmptyArray(selectedItems)) {
    return (
      <Typography
        color={'textSecondary'}
        sx={{
          paddingLeft: 1,
          fontWeight: 400,
          fontSize: '14px'
        }}>
        {placeholder}
      </Typography>
    );
  }

  const itemsToShow = takeFromStart(selectedItems, maxChipsInInputArea);
  const remainingCount = selectedItems.length - itemsToShow.length;

  return (
    <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {itemsToShow.map((item) => (
        <Chip
          onMouseDown={swallowClick}
          sx={{ width: 85, display: 'flex', justifyContent: 'space-between' }}
          key={item.value}
          label={item.label}
          size="small"
          onDelete={() => onDelete?.(item)}
        />
      ))}
      {remainingCount > 0 && <Chip sx={{ marginLeft: 'auto' }} size="small" label={`+${remainingCount}`} />}
    </Box>
  );
};
